// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","iframe":"iframe-hEEE1"};